// extracted by mini-css-extract-plugin
export default {"container":"ConfirmateLeg_container__EnoEv","contentMessage":"ConfirmateLeg_contentMessage__jdLHp"};